module.exports = require('./helpers/bundle-url').getBundleURL('1G2bZ') + "navbar-logo.bd1ca002.svg" + "?" + Date.now();